"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./rinkebyCryptoKitties/index");
var index_2 = require("./rinkebyCustom/index");
var index_3 = require("./rinkebyENSName/index");
var index_4 = require("./rinkebyOwnableContract/index");
var index_5 = require("./testRinkebyNFT/index");
exports.rinkebySchemas = [index_1.rinkebyCryptoKittiesSchema, index_2.rinkebyCustomSchema, index_3.rinkebyENSNameSchema, index_4.rinkebyOwnableContractSchema, index_5.testRinkebyNFTSchema];
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/wyvern-schemas/dist/schemas/rinkeby/index.js